import Cookies from 'js-cookie'
import { env } from '@/store'
import buildUrl from '@/utils/buildUrl.utils'

/**
 * Quando o usuário está deslogado e chega com os query params `code` e `state`
 * (callback OAuth da conta Stone), redireciona para a conta Stone
 * (`VUE_APP_ACCOUNT_URL`) preservando `code` e `state`.
 *
 * Roda no bootstrap, antes do router — portanto antes do `routeAffiliationsCreated`
 * e antes da cadeia 401 → `DELETE_AUTHORIZATION` → `id.pagar.me`.
 *
 * "Deslogado" é detectado de forma síncrona via cookies de sessão
 * (`${acronym}mp_tk` / `${acronym}mp_rt`), espelhando o teste da support-lib.
 *
 * @returns {boolean} `true` se disparou o redirect (o app não deve ser montado).
 */
export function redirectLoggedOutToStoneAccount () {
  const accountUrl = process.env.VUE_APP_ACCOUNT_URL
  if (!accountUrl) return false

  const params = new URLSearchParams(window.location.search)
  const code = params.get('code')
  const state = params.get('state')
  if (!code || !state) return false

  const isLoggedOut = !Cookies.get(`${env}mp_tk`) || !Cookies.get(`${env}mp_rt`)
  if (!isLoggedOut) return false

  window.location.assign(buildUrl({ url: accountUrl, queryString: { code, state } }))
  return true
}
